
import '@/assets/scss/index.scss'

import VueClipBoard from 'vue-clipboard2'
import Vue from 'vue'
import OrderListCmp from '@/components/cs/or/OrderListCmp.vue' // 마이페이지 주문 목록
import { commonfunc } from '~/mixin/common'
import { csMixin } from '~/mixin/cs/csMixin'
export default {
  name: 'CSH0003',
  components: {
    OrderListCmp
  },
  mixins: [commonfunc, csMixin],
  layout: 'DsMainLayout',
  props: {
    orderList: {
      type: Object,
      default: () => {}
    },
    searchForm: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      faqList: [],
      title: ''
    }
  },
  beforeMount () {
  },
  mounted () {
    this.selFaqList(this.searchForm)
  },
  methods: {
    copyOrNo () {
      VueClipBoard.config.autoSetContainer = true
      Vue.use(VueClipBoard)
      this.$copyText(this.orderList.orNo)
      this.openToast('복사성공')
    },
    selFaqList (searchForm) {
      this.$AxiosBuilder
        .data(searchForm)
        .build()
        .post('/cs/csh/faqList')
        .then((res) => {
          console.log(res)
          this.faqList = res.data.data
          this.title = this.faqList[0].faqMnTyCdNm
        })
    },
    handleFaqDtl (faqNo) {
      const searchForm = {
        faqNo
      }
      // this.$router.push({ name: 'cs-csh-SCR_CSH_0004', params: { form: JSON.stringify(searchForm), prevProdItem: JSON.stringify(this.orderList), prevForm: JSON.stringify(this.searchForm) } })
      this.$emit('callback-event', JSON.stringify(searchForm))
    },
    goBack () {
      // this.$router.push({ name: 'cs-csh-SCR_CSH_0002', params: { prodItem: JSON.stringify(this.orderList) } })
      this.$parent.backCmpHandler('Csh0002')
    }
  }
}
